import React from 'react';
import 'boxicons/css/boxicons.min.css';
import './CommonInsuranceSection.scss';
import '../HomePageSections.scss';
import insauranceLogo from '../../../../assets/images/HomePageImages/insurance-logos-1.png';
const CommonInsuranceSection = () => {
    return (
        <div className='common-section insurance-section'>
            <div className='common-section-content text'>
                <h1>Our Insurance Partners</h1>
            </div>
            <div className='common-section-content'>
                <div className='image-container'>
                    <img className='dashboard-image' src={insauranceLogo} alt="" />
                </div>
            </div>
        </div>
    );
};

export default CommonInsuranceSection;
